<template>
  <v-col cols="12" sm="12" md="12">
    <v-tabs :key="render"
      class="a-tabs pb-2 tab-align-lang-style"
      v-model="selectedTab"
      show-arrows
      height="38"
      style="background-color: var(--v-Neutral-base)"
      right
      @change="onTabChange"
    >
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab class="generalTab">
        {{ $t("agenda.lblGeneralAgendaTab") }}
      </v-tab>
      <v-tab class="annualTab">
        {{ $t("agenda.lblAnnualAgendaTab") }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="currentTab">
      <v-tab-item>
        <v-card
          style="width: 100%"
          elevation="0"
          color="Neutral"
          class="pb-2 pl-1" 
        >
          <v-card-text class="pa-0">
            <meeting-filter :btn-text="false" small></meeting-filter>
            <agenda-meeting-type-filter v-model="selectedMeetingTypes">
            </agenda-meeting-type-filter>
          </v-card-text>
        </v-card>
        <v-card style="width: 100%" elevation="0" color="Neutral">
          <v-card-text class="ma-0 p-3">
            <v-row v-resize="onResize" >
              <v-col cols="12" sm="12" md="12" style="padding: 0px">
                <agenda-view-grid
                  :key="renderAgendaView"
                  :gridData="filteredMeetingData"
                  :gridHeight="screenHeight"
                  :searchText="search"
                ></agenda-view-grid>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card style="width: 100%" elevation="0" color="Neutral">
          <v-card-text class="ma-0 p-0">
            <v-row v-resize="onResize">
              <v-col cols="12" sm="12" md="12" style="padding: 0px">
                <agenda-view-schedule
                  :key="renderYearlyAgendaView"
                  ref="agendaViewSchedule"
                  :agendaData="newAgendaList"
                  :schedulerHeight="scheduleHeight"
                  :meetingList="newMeetings"
                  :agendaCategoryData="newAgendaCategories"
                  @loadMore="loadMoreAgendas"
                  @yearChange="yearChange"
                />
              </v-col>
            </v-row>
          </v-card-text></v-card>
      </v-tab-item>
    </v-tabs-items>
    <v-card
      v-if="false"
      style="width: 100%"
      elevation="0"
      color="Neutral"
      class="mb-4"
    >
      <v-card-text class="pa-0">
        <meeting-filter :btn-text="false" small></meeting-filter>
        <agenda-meeting-type-filter v-model="selectedMeetingTypes">
        </agenda-meeting-type-filter>
      </v-card-text>
    </v-card>
    <v-card style="width: 100%" elevation="0" color="Neutral" v-if="false">
      <v-card-text class="ma-0 pa-2">
        <v-row v-resize="onResize" v-if="false">
          <v-col cols="12" sm="12" md="12" style="padding: 0px">
            <agenda-view-grid
              :gridData="filteredMeetingData"
              :gridHeight="screenHeight"
              :searchText="search"
            ></agenda-view-grid>
          </v-col>
        </v-row> 
        <v-row v-resize="onResize">
          <v-col cols="12" sm="12" md="12" style="padding: 0px">
            <agenda-view-schedule
              ref="agendaViewSchedule"
              :agendaData="newAgendaList"
              :schedulerHeight="scheduleHeight"
              :meetingList="newMeetings"
              :agendaCategoryData="agendaCategories"
              @loadMore="loadMoreAgendas"
              @yearChange="yearChange"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import MeetingFilter from "@/components/agenda/MeetingFilter.vue";
import AgendaViewGrid from "./AgendaViewGrid.vue";
import AgendaMeetingTypeFilter from "./AgendaMeetingTypeFilter.vue";
import AgendaViewSchedule from "./AgendaViewSchedule.vue";
import { getDateRange } from "../../utils/util";
export default {
  components: {
    AgendaViewGrid,
    MeetingFilter,
    AgendaMeetingTypeFilter,
    AgendaViewSchedule,
  },
  name: "AgendaMeetingView",
  props: {
    search: String,
  },
  data() {
    return {
      render: 0,
      renderAgendaView: 0,
      renderYearlyAgendaView: 0,
      selectedTab: 0,
      currentTab: 0,
      navigateTab: 0,
      isLoadMore: false,
      selectedMeetingTypes: [],
      screenHeight: 0,
      scheduleHeight: 0,
      newAgendaList: [],
      newMeetings: [],
      newAgendaCategories: []
    };
  },
  watch: {
    '$i18n.locale': {
      immediate: true,
      async handler() {
        this.render++;
      }
    }
  },
  computed: {
    ...mapState({
      meetingsByAgenda: (state) => state.agenda.meetingsByAgenda,
      newMeetingsByAgenda: (state) => state.agenda.newMeetingsByAgenda,
      meetingListData: (state) => state.meeting.meetingsList,
      getFirstMonthOfYear: (state) => state.agenda.firstMonthOfYear
    }),
    ...gettersMap(),
    meetinglist() {
      const data = this.meetingListData.map((item) => ({
        ...item,
        title: item.meetingName,
        meetingType: this.meetingTypesList.find(
          (c) =>
            String(c.label).toLowerCase() ===
            String(item.meetingType).toLowerCase()
        ) || { label: item.meetingType, color: "#F5CBA7" },
      }));
      data.sort(function (a, b) {
        return (
          new Date(a.scheduletStartTimeInUTC).getTime() -
          new Date(b.scheduletStartTimeInUTC).getTime()
        );
      });
      return data;
    },
    meetingData() {
      return this.meetinglist;
    },
    meetingTypeItems() {
      return this.meetingTypesList.filter((item) => {
        if (this.$security.checkMeetingTypeAccess(item.id, "ViewMeeting")) {
          return item;
        }
      });
    },
    filteredMeetingData() {
      return this.filterMeetings(this.selectedMeetingTypes);
    },
  },
  methods: {
    ...mapActions({
      getMeetingByAgendaId: "agenda/getMeetingByAgendaId",
      setActiveAgendaUITab: "agenda/setActiveAgendaUITab",
    }),
    filterMeetings(selectedMeetings) {
      if (selectedMeetings.length === 0) {
        return this.meetingData;
      } else {
        const selectedMeetingsLabels = selectedMeetings.map(meeting => meeting.label);
        return this.meetingData.filter(meeting =>
          selectedMeetingsLabels.includes(meeting.meetingType.label)
        );
      }
    },
    onTabChange() {
      this.$nextTick(() => {
        this.navigateTab = this.selectedTab;
        this.selectedTab = this.currentTab;
      });
      this.currentTab = this.selectedTab;
      this.setActiveAgendaUITab(this.currentTab);
      if(this.currentTab === 1) {
        this.loadYearlyAgendaView(this.meetingsByAgenda.length);
      }
      this.currentTab === 0 ? this.renderAgendaView++ : 0;
    },
    async loadYearlyAgendaView(data) {
      let date = new Date(new Date().getFullYear(), this.getFirstMonthOfYear, 1) || new Date();
      let dates = getDateRange(date);

      const obj = {
        offset: 0,
        limit: 15,
        from_year: dates.from_year,
        to_year: dates.to_year
      };
      this.newMeetings = [];
      this.newAgendaList = [];
      this.newAgendaCategories = [];      
      this.getMeetingByAgenda(obj, !Boolean(data));
    },
    loadMoreAgendas(value) {
      this.isLoadMore = true;
      this.getMeetingByAgenda(value);
    },
    yearChange(value) {
      this.isLoadMore = false;
      this.newMeetings = [];
      this.newAgendaList = [];
      this.newAgendaCategories = [];
      this.getMeetingByAgenda(value, true);
    },
    async getMeetingByAgenda(obj, val) {
      if(val) {
        this.$store.commit('agenda/MEETING_BY_AGENDA', [])
      }
      if (this.meetingsByAgenda.length && this.isLoadMore) {
        await this.getMeetingByAgendaId({obj, isLoadMore: this.isLoadMore, initial: !val});
      } else if (this.meetingsByAgenda.length) {
        await this.getMeetingByAgendaId({obj, isLoadMore: false, initial: !val});
      } else {
        await this.getMeetingByAgendaId({obj, isLoadMore: false, initial: val});
      }

      if (!this.meetingsByAgenda.length)
        this.$refs.agendaViewSchedule.setAgendaUI();
      
      if(val) {
       this.scheduleData(this.meetingsByAgenda, val)}
      else {
        this.scheduleData(this.newMeetingsByAgenda)
      }
    },
    onResize() {
      this.screenHeight = window.innerHeight - 240;
      this.scheduleHeight = window.innerHeight - 190;
    },
    scheduleData(val = [], initial) {
      if(initial) {
        this.newMeetings = [];
        this.newAgendaList = [];
        this.newAgendaCategories = [];
      }
      
      val?.map((res) => {
        const category = this.tenantSettingTypes("category")
          ?.find(i => i.id === res.agenda_category_id);
          
        if (category && !this.newAgendaCategories.some(i => i.id === category.id)) {
          this.newAgendaCategories.push(category);
        }

        let newAgenda = {
          id: res.agenda_id,
          agendaName: res.agenda_name,
          agendaCategoryId: res.agenda_category_id,
          agendaCategoryName: res.agenda_category
        };
        if(newAgenda && !this.newAgendaList.some(i => i.id === newAgenda.id)) {
          this.newAgendaList.push(newAgenda);
        }

        res?.meetings.forEach((meet) => {
          Object.assign(meet, {
            agenda_category: res.agenda_category,
            agenda_category_id: res.agenda_category_id,
            agenda_id: res.agenda_id,
            agenda_name: res.agenda_name,
          });
        });
        this.newMeetings.push(...(res.meetings || []));
      });
    }
  },
};

function gettersMap() {
  return mapGetters({
    meetingTypesList: "tenant/agendaMeetingTypes",
    getFilteredResultApi: "meeting/getFilteredResult",
    tenantSettingTypes: "tenant/tenantSettingTypes",
  });
}
</script>

<style  scoped>
.a-tabs .v-tab--active {
  background: #dde3ee;
}
::v-deep .a-tabs > .v-tabs-bar {
  background: transparent !important;
}
.tab-align-lang-style .v-tab.generalTab , .tab-align-lang-style .v-tab.annualTab{
  /* width: 180px; */
}
::v-deep .v-card__text {
  width: 100%;
}

::v-deep .alignMiddle {
  margin-top: 2px;
}
::v-deep .v-card--link:focus:before {
  opacity: 0;
}
</style>